import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getConversation, getMessages } from '../lib/api-client';
import { useAuth } from '../context/AuthContext';
import MessagesClient from '../components/desktop/MessagesClient';
import LoadingScreen from '../components/desktop/LoadingScreen';

export default function MessageThread() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user: authUser, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(true);
  const [currentUserId, setCurrentUserId] = useState<string>('');
  const [currentUserName, setCurrentUserName] = useState<string>('');
  const [conversation, setConversation] = useState<any>(null);
  const [messages, setMessages] = useState<any[]>([]);

  useEffect(() => {
    async function loadData() {
      if (!id || authLoading || !authUser) {
        if (!id) navigate('/messages');
        return;
      }

      try {
        const conv = await getConversation(id);
        const msgs = await getMessages(id);

        // Check if user is a participant
        const isParticipant = conv.participants?.some(
          (p: any) => p.userId.toString() === authUser.id.toString()
        );

        if (!isParticipant) {
          navigate('/messages');
          return;
        }

        setCurrentUserId(authUser.id.toString());
        setCurrentUserName(authUser.displayName || authUser.username);

        const transformedConversation = {
          id: conv.id,
          type: conv.type,
          name: conv.name,
          creatorId: conv.creatorId?.toString(),
          participants: conv.participants?.map((p: any) => ({
            id: p.userId.toString(),
            username: p.user.username,
            displayName: p.displayName || p.user.profileName || p.user.name || p.user.username,
          })),
          themePresetKey: 'ocean-turtle',
          themeOverrides: {},
        };

        const initialMessages = msgs.map((m: any) => ({
          id: m.id,
          from: m.fromUserId.toString(),
          text: m.text,
          at: m.at,
        }));

        setConversation(transformedConversation);
        setMessages(initialMessages);
      } catch (error) {
        navigate('/messages');
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [id, authUser, authLoading, navigate]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!conversation) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--app-bg)', color: 'var(--text-color)' }}>
        <div className="text-xl">Conversation not found</div>
      </div>
    );
  }

  return (
    <MessagesClient
      currentUserId={currentUserId}
      currentUserName={currentUserName}
      conversation={conversation}
      initialMessages={messages}
    />
  );
}
